import { render, staticRenderFns } from "./ValorDoRebanhoMedioPorCategoriaAnimalAbsoluto.vue?vue&type=template&id=15e75038&scoped=true&"
import script from "./ValorDoRebanhoMedioPorCategoriaAnimalAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ValorDoRebanhoMedioPorCategoriaAnimalAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e75038",
  null
  
)

export default component.exports